module.exports = __webpack_public_path__ + "static/media/MHRP29N0026.ca70700f.svg";